<template>
  <div class="date-container" ref="flatpickr">
    <input
      ref="eInput"
      type="text"
      data-input
      class="w-100 m-0 input-group-alternative form-control-sm input-height"
    />

    <div v-show="date" data-clear class="x-container">
      <div class="x-button">
        <i class="fa fa-times"></i>
      </div>
    </div>
  </div>
</template>

<script>
import flatpickr from "flatpickr";
import flatpickrEs from "@/data/flatpickrEs.json";
export default {
  data() {
    return {
      date: null,
    };
  },
  mounted() {
    this.picker = flatpickr(this.$refs["flatpickr"], {
      onChange: this.onDateChanged.bind(this),
      dateFormat: "d/m/Y",
      altFormat: "Y-m-d",
      altInput: true,
      wrap: true,
      locale: flatpickrEs,
      // enableTime: this.params.filterParams.enableTime, // custom parameter
      // minuteIncrement: 1,
      // time_24hr: true
    });

    this.eInput = this.$refs["eInput"];

    this.picker.calendarContainer.classList.add("ag-custom-component-popup");
  },
  methods: {
    onDateChanged(selectedDates) {
      this.date = selectedDates[0] || null;
      this.params.onDateChanged();
    },

    getDate() {
      return this.date;
    },

    setDate(date) {
      this.picker.setDate(date);
      this.date = date || null;
    },
  },
};
</script>

<style>
.ag-custom-component-popup {
  .flatpickr-months .flatpickr-prev-month, .flatpickr-months .flatpickr-next-month {
    top: 18px;
  }
  .flatpickr-months .flatpickr-prev-month.flatpickr-prev-month, .flatpickr-months .flatpickr-next-month.flatpickr-prev-month {
    left: 20px;
}
.flatpickr-months .flatpickr-prev-month.flatpickr-next-month, .flatpickr-months .flatpickr-next-month.flatpickr-next-month {
  right: 20px;
}
.flatpickr-innerContainer{
  margin-top: 16px;
}
}
</style>

<style scoped>
.date-container {
  position: relative;
  width: 100%;
  .form-control:disabled,
  .form-control[readonly] {
    background-color: white;
  }
  .form-control-sm {
    height:24px !important;
    font-size: 11px;
  }
}
.x-container {
  width: 30px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.x-button {
  display: none;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  background-color: #f4f5f7;
  height: 20px;
  width: 20px;
}
.date-container:hover .x-button {
  display: flex;
}
.x-container:hover .x-button {
  background-color: #e9ecef;
}

</style>
